import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import { PatternFormat } from 'react-number-format';

function AggregatorPhoneForm({ aggregatorPhoneNumber, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Phone number:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <PatternFormat
          name="phoneNumber"
          id="phoneNumber"
          format="(###) ###-####"
          mask="_"
          className="bo-input"
          allowEmptyFormatting
          customInput={Form.Control}
          value={aggregatorPhoneNumber || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(AggregatorPhoneForm);
